namespace RioERP.Masters {
    export interface PendingOrderJobSettingsRow {
        Id?: number;
        NopUrl?: string;
        RunJob?: boolean;
    }

    export namespace PendingOrderJobSettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'NopUrl';
        export const localTextPrefix = 'Masters.PendingOrderJobSettings';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            NopUrl = "NopUrl",
            RunJob = "RunJob"
        }
    }
}
